module.exports = __webpack_public_path__ + "img/phone.c7263e32.png";